import MainLayout from "../src/MainLayout/MainLayout";
import { DefaultProvider } from "./components/context/defaultcontext";
import { ProjectProvider } from "./components/context/ProjectContext";
import { ModalManagerProvider } from "./components/context/ModalContext";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import DashboardPage from "./pages/super-admin-dashboard/DashboardPage";
import CompaniesButton from "./pages/super-admin-dashboard/CompaniesButton";
import SubscriptionPage from "./pages/super-admin-dashboard/SubscriptionPage";
import PackagesPages from "./pages/super-admin-dashboard/PackagesPages";
import PackagesPlansPage from "./pages/super-admin-dashboard/PackagesPlansPage";
import DomainPage from "./pages/super-admin-dashboard/DomainPage";
import AgentsPage from "./pages/super-admin-dashboard/Tickets/AgentsPage";
import SLAPoliciesPage from "./pages/super-admin-dashboard/Tickets/SLAPoliciesPage";
import EscalationsRulesPage from "./pages/super-admin-dashboard/Tickets/EscalationsRulesPage";

import EmailsPage from "./pages/Applications/EmailsPage";
import ChatsPage from "./pages/Applications/ChatsPage";
import KanbanPage from "./pages/Applications/KanbanPage";
import HRDashboardPage from "./pages/Dashboard/HR-Dashboard/HRDashboardPage";
import LeaveEmployeesPage from "./pages/Dashboard/HR-Dashboard/LeaveEmployeesPage";
import AdminDashboardPage from "./pages/Dashboard/AdminDashboard/AdminDashboardPage";
import EmployeeDashboardPage from "./pages/Dashboard/EmployeeDashboard/EmployeeDashboardPage";
import DealsDashboardPage from "./pages/Dashboard/DealsDashboard/DealsDashboardPage";
import LeadsDashboardPage from "./pages/LeadsDashboard/LeadsDashboardPage";
import CompanyDetails from "./pages/LeadsDashboard/CompanyDetails";
import RecruitmentDashboardPage from "./pages/Dashboard/RecruitmentDashboard/RecruitmentDashboardPage";
import AttendanceDashboardPage from "./pages/Dashboard/AttendanceDashboard/AttendanceDashboardPage";
import FinancialDashboardPage from "./pages/FinanceDashboard/FinanceDashboardPage";
import BudgetsPage from "./pages/FinanceDashboard/BudgetsPage";
import ITAdminDashboardPage from "./pages/super-admin-dashboard/ITAdminDashbaord/ITAdminDashboardPage";
import HelpDeskDashboardPage from "./pages/Dashboard/HelpDeskDashboard/HelpDeskDashboardPage";
import PayrollDashboardPage from "./pages/PayrollDashboard/PayrollDashboardPage";

import EmployeesGridPage from "./pages/HRM/EmployeesList/EmployeesGridPage";
import EmployeesListPage from "./pages/HRM/EmployeesList/EmployeesListPage";
import AttendanceReportPage from "./pages/Administration/AttendanceReportPage";
import JobsPage from "./pages/Administration/JobsPage";

import CandidatesList from "./pages/Administration/CandidatesList";
import CandidatesGrid from "./pages/Administration/CandidatesGrid";
import CandidatesKanban from "./pages/Administration/CandidatesKanban";
import ProjectList from "./pages/Projects/ProjectList";
import ProjectGrid from "./pages/Projects/ProjectGrid";
import ProjectDetails from "./pages/Projects/ProjectDetails";
import ActivityPage from "./pages/CRM/Activity/ActivityPage";

import SettingsPage from "./pages/Settings/SettingsPage";
// import DealsList from "./pages/CRM/Deals/DealsList";
import DealsGrid from "./pages/CRM/Deals/DealsGrid";
import DealsPage from "./components/crm/deals/DealsHeader";
import DealsList from "./pages/CRM/Deals/DealsList";
import Login from "./pages/Authentication/Login";
import Signup from "./pages/Authentication/Signup";
import RecentTransactionsPage from "./pages/super-admin-dashboard/RecentTransactionsPage";
import InvoiceDetails from "./pages/Applications/InvoiceDetails";
import InvoicesPage from "./pages/Applications/InvoicesPage";
import AddInvoices from "./components/modals/invoices/AddInvoices";
import DatePickerPage from "./pages/Applications/DatePickerPage";
import PaymentsPage from "./pages/Sales/PaymentsPage";
import ContactList from "./pages/CRM/Contact/ContactList";
import ContactGrid from "./pages/CRM/Contact/ContactGrid";
import LeadsGrid from "./pages/CRM/Leads/LeadsGrid";
import LeadsList from "./pages/CRM/Leads/LeadsList";
import CalendarPage from "./pages/Applications/CalendarPage";
import NotesPage from "./pages/Applications/NotesPage";
import CompaniesGrid from "./pages/CRM/Companies/CompaniesGrid";
import CompaniesList from "./components/super-admin/dashbaord/CompaniesList";
import CompaniesListPage from "./pages/CRM/Companies/CompaniesListPage";
import PipelinePage from "./pages/CRM/Pipeline/PipelinePage";
import EmployeesDetailsPage from "./pages/HRM/EmployeesList/EmployeesDetailsPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import LeavesPage from "./pages/HRM/Attendance/LeavesPage";
import ForgotPassword from "./pages/Authentication/ForgotPassword";
import ResetPassword from "./pages/Authentication/ResetPassword";
import OtpVerification from "./pages/Authentication/OtpVerification";
import TermsConditions from "./pages/TermsConditions";
import FaqPage from "./pages/FaqPage";
import HolidaysPage from "./pages/HRM/HolidaysPage";
import DepartmentPage from "./pages/HRM/DepartmentPage";
import DesignationsPage from "./pages/HRM/EmployeesList/DesignationsPage";
import ResignationPage from "./pages/HRM/ResignationPage";
import TerminationPage from "./pages/HRM/TerminationPage";
import TicketListPage from "./pages/HRM/Tickets/TicketListPage";
import TicketGridPage from "./pages/HRM/Tickets/TicketGridPage";
import TicketDetails from "./pages/HRM/Tickets/TicketDetails";

function App() {
  return (
    <BrowserRouter>
      <DefaultProvider>
        <ProjectProvider>
          <ModalManagerProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/sign-up" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword/>} />
              <Route path="/reset-password" element={<ResetPassword/>} />

              <Route path="/otp-verification" element={<OtpVerification/>} />

              <Route
                path="*"
                element={
                  <MainLayout>
                    <Routes>
                      {/* <Route path="/" element={<h2>Welcome to Dashboard 🚀</h2>} /> */}

                      <Route path="/" element={<AdminDashboardPage />} />
                      <Route path="/profile" element={<ProfilePage />} />

                      {/* Dashboard */}
                      {/* Hr-dashbaord */}
                      <Route
                        path="/hr-dashboard"
                        element={<HRDashboardPage />}
                      />
                      <Route
                        path="/payroll-dashboard"
                        element={<PayrollDashboardPage />}
                      />
                      <Route
                        path="/leave-page"
                        element={<LeaveEmployeesPage />}
                      />

                      {/* Admin-DashboardPage */}

                      <Route path="/" element={<AdminDashboardPage />} />
                      <Route path="/jobs" element={<JobsPage />} />

                      {/* EmployeeDashboardPage */}
                      <Route
                        path="/employee-dashboard"
                        element={<EmployeeDashboardPage />}
                      />
                      {/* Deals Dashboard */}
                      <Route
                        path="/deals-dashboard"
                        element={<DealsDashboardPage />}
                      />

                      {/* LeadsDashboardPage */}
                      <Route
                        path="/leads-dashboard"
                        element={<LeadsDashboardPage />}
                      />
                      <Route
                        path="/company-details"
                        element={<CompanyDetails />}
                      />
                      {/* RecruitmentDashboardPage */}
                      <Route
                        path="/recruitment-dashboard"
                        element={<RecruitmentDashboardPage />}
                      />
                      {/* Attendancedashboard */}
                      <Route
                        path="/attendance-dashboard"
                        element={<AttendanceDashboardPage />}
                      />
                      {/* FinancialDashboard */}
                      <Route
                        path="/financial-dashboard"
                        element={<FinancialDashboardPage />}
                      />

                      {/* BudgetsPage */}
                      <Route path="/budget-page" element={<BudgetsPage />} />

                      {/* ITAdminDashbaord  */}
                      <Route
                        path="/it-admin-dashboard"
                        element={<ITAdminDashboardPage />}
                      />
                      {/* HelpDeskDashboard */}
                      <Route
                        path="/helpdesk-dashboard"
                        element={<HelpDeskDashboardPage />}
                      />

                      {/* Superadmin-dashboard */}
                      {/* dashboard */}
                      <Route
                        path="/superadmin-dashboard"
                        element={<DashboardPage />}
                      />
                      <Route
                        path="/companies-button"
                        element={<CompaniesButton />}
                      />
                      <Route
                        path="/subscription-page"
                        element={<SubscriptionPage />}
                      />
                      <Route
                        path="/packages-pages"
                        element={<PackagesPages />}
                      />
                      <Route
                        path="/packages-cp-pages"
                        element={<PackagesPlansPage />}
                      />
                      <Route path="/domain-Page" element={<DomainPage />} />
                      <Route
                        path="/recent-transactions"
                        element={<RecentTransactionsPage />}
                      />

                      {/* Tickets */}
                      <Route path="/agents-page" element={<AgentsPage />} />
                      <Route
                        path="/sla-policies-page"
                        element={<SLAPoliciesPage />}
                      />
                      <Route
                        path="/escalations-rules-page"
                        element={<EscalationsRulesPage />}
                      />

                      {/* Applications */}
                      {/* chat */}
                      <Route path="/chats-page" element={<ChatsPage />} />
                      {/* calendar */}
                      <Route path="/calendar-page" element={<CalendarPage />} />

                      <Route path="/notes-page" element={<NotesPage />} />

                      {/* emails */}
                      <Route path="/emails-page" element={<EmailsPage />} />
                      {/* kanban */}
                      <Route path="/kanban-page" element={<KanbanPage />} />
                      <Route path="/invoices-page" element={<InvoicesPage />} />
                      <Route
                        path="/companies-grid"
                        element={<CompaniesGrid />}
                      />
                      <Route
                        path="/companies-list"
                        element={<CompaniesListPage />}
                      />

                      <Route
                        path="/invoice-details"
                        element={<InvoiceDetails />}
                      />
                      <Route path="/add-invoices" element={<AddInvoices />} />
                      <Route path="/date-picker" element={<DatePickerPage />} />

                      {/* hrm */}
                      {/* Attendance */}
                      <Route path="/leaves" element={<LeavesPage/>} />

                      <Route path="/departments" element={<DepartmentPage/>} />
                      <Route path="/designations" element={<DesignationsPage/> } />
                      <Route path="/resignation" element={<ResignationPage/>} />
                      <Route path="/termination" element={<TerminationPage/>} />

                      {/* EmployeesList */}
                      <Route
                        path="/employee-lists"
                        element={<EmployeesListPage />}
                      />
                      {/* Employees Grid */}
                      <Route
                        path="/employee-grid"
                        element={<EmployeesGridPage />}
                      />
                      <Route path="/tickets-list" element={<TicketListPage/>} />
                      <Route path="/tickets-Grid" element={<TicketGridPage/>} />
                      <Route path="/tickets-details" element={<TicketDetails/>} />
        
                      <Route path="/holidays" element={<HolidaysPage/>} />

                      <Route
                        path="/employee-grid"
                        element={<EmployeesGridPage />}
                      />
                      {/* Administration */}
                      <Route
                        path="/employee-details"
                        element={<EmployeesDetailsPage />}
                      />
                      {/* <Route path="/candaite" element={<CandidatesList />} /> */}
                      {/* candidates */}
                      <Route
                        path="/candidates-list"
                        element={<CandidatesList />}
                      />
                      <Route
                        path="/candidates-grid"
                        element={<CandidatesGrid />}
                      />
                      <Route
                        path="/candidates-kanban"
                        element={<CandidatesKanban />}
                      />

                      <Route path="/attendance-report" element={<AttendanceReportPage/>} />

                      {/* Sales */}
                      <Route path="/payments-page" element={<PaymentsPage />} />

                      {/* projects */}
                      <Route path="/projects" element={<ProjectList />} />
                      <Route path="/project-list" element={<ProjectList />} />
                      <Route path="/project-grid" element={<ProjectGrid />} />
                      <Route
                        path="/project-details/:id"
                        element={<ProjectDetails />}
                      />

                      {/* CRM */}
                      {/* Activity */}

                      {/* contact              */}
                      <Route
                        path="/"
                        element={<Navigate to="/contact-list" />}
                      />
                      <Route path="/contact-list" element={<ContactList />} />
                      <Route path="/contact-grid" element={<ContactGrid />} />
                      {/* Leads                    */}
                      <Route path="/" element={<Navigate to="/leads-list" />} />
                      <Route path="/leads-list" element={<LeadsList />} />
                      <Route path="/leads-grid" element={<LeadsGrid />} />
                      {/* deals */}
                      <Route path="/deals" element={<DealsPage />} />
                      <Route path="/deals-list" element={<DealsList />} />
                      <Route path="/deals-grid" element={<DealsGrid />} />
                      <Route path="/pipeline" element={<PipelinePage />} />

                      <Route path="/activity" element={<ActivityPage />} />
                      {/* settings */}
                      <Route path="/settings" element={<SettingsPage />} />
                      <Route path="/terms-conditions" element={<TermsConditions />} />
                      <Route path="/faq" element={<FaqPage/>} />


                 
                    </Routes>
                  </MainLayout>
                }
              />
            </Routes>
          </ModalManagerProvider>
        </ProjectProvider>
      </DefaultProvider>
    </BrowserRouter>
  );
}

export default App;
